'use client';

import { Edit03, Trash01 } from '@ethsign/icons';
import { Input, useToast } from '@ethsign/ui';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { CheckGreenIcon, CircleCheckedIcon, CircleIcon, UserIcon } from '@/components';

import { DeleteSignerModal } from '../Modal/DeleteSignerModal';

interface Props {
  id: string;
  isActive: boolean;
  isCompleted?: boolean;
  name: string;
  onClick: () => void;
  onEdit: (item: { name: string; id: string }) => void;
  onDelete: (id: string) => void;
  isEditing?: boolean;
  i: number;
}
const colors = [
  { text: '#DC6803', bg: '#FCE4EC' },
  { text: '#D81B60', bg: '#FFFAEB' },
  { text: '#1570EF', bg: '#F5FBEE' },
  { text: '#175CD3', bg: '#EFF8FF' },
  { text: '#088AB2', bg: '#ECFDFF' },
  { text: '#764C97', bg: '#EBE5F0' },
  { text: '#475467', bg: '#F9FAFB' },
  { text: '#D92D20', bg: '#FEF3F2' }
];

const colorsLen = colors.length;
export function SignerItem(props: Props) {
  const { id, isActive, name, onClick, onEdit, onDelete, i, isCompleted } = props;
  const [isEditing, setIsEditing] = useState(props.isEditing);
  const [hover, setHover] = useState(false);
  const [tempName, setTempName] = useState(name);
  const [openModal, setOpenModal] = useState(false);
  const { toast } = useToast();
  const inputRef = useRef<any>(null);
  useEffect(() => {
    setTempName(name);
  }, [name]);
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);
  return (
    <div
      className={`${
        isActive ? 'bg-primary-50 border-primary-600' : ''
      } relative cursor-pointer mb-2 py-3 px-[14px] border border-gray-200 rounded-lg flex flex-row  justify-between items-center w-full`}
      onClick={onClick}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <span className="flex flex-1 flex-row items-center">
        <UserIcon fill={colors[i % colorsLen].text} />
        <span
          className={classNames('flex-1 mx-2 text-md font-medium text-gray-500 truncate w-1', {
            'text-primary-900': isActive
          })}
        >
          {isEditing ? (
            <Input
              ref={inputRef}
              className="w-[130px] font-normal text-sm"
              placeholder={name}
              defaultValue={name}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onBlur={(e) => {
                if (e.target.value) {
                  setIsEditing(false);
                  setTempName(e.target.value);
                  onEdit({ name: e.target.value, id });
                } else {
                  inputRef.current.focus();
                  toast({ title: 'Error', description: 'Folder name cannot be empty', variant: 'error' });
                }
              }}
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  if (e.target.value) {
                    setIsEditing(false);
                    setTempName(e.target.value);
                    onEdit({ name: e.target.value, id });
                  } else {
                    inputRef.current.focus();
                    toast({ title: 'Error', description: 'Folder name cannot be empty', variant: 'error' });
                  }
                }
              }}
            ></Input>
          ) : (
            tempName
          )}
        </span>

        {hover ? (
          <div
            className="flex flex-row"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span
              className="mr-2"
              onClick={() => {
                setIsEditing(true);
              }}
            >
              <Edit03 size={16} color="#98A2B3"></Edit03>
            </span>
            <span
              onClick={() => {
                setOpenModal(true);
              }}
            >
              <Trash01 size={16} color="#98A2B3"></Trash01>
            </span>
          </div>
        ) : (
          <div className="mr-2">
            {isCompleted ? <CheckGreenIcon /> : isActive ? <CircleCheckedIcon /> : <CircleIcon />}
          </div>
        )}
      </span>
      <DeleteSignerModal
        open={openModal}
        onOpenChange={setOpenModal}
        onConfirm={() => {
          setOpenModal(false);
          onDelete(id);
        }}
        onCancel={() => {
          setOpenModal(false);
        }}
      />
    </div>
  );
}
